import { Query } from '../../../../../hooks/queries'
import { useContrastQuery } from '../../../../../hooks/use-contrast-query'
import { ThisConnector } from '../../../../../api/connector'

interface ApiKeysArgs {
  organizationUuid: string
  agentUid?: string
}

export interface ApiKeysResponse {
  success: boolean
  messages: string[]
  api_key: string
  service_key: string
  user_id: string
  user_uid: string
  token: string
}

export async function getApiKeys(
  this: ThisConnector,
  { organizationUuid, agentUid }: ApiKeysArgs
) {
  const baseUrl = `/${organizationUuid}/users/keys/servicekey/agentuser`
  const queryParams = agentUid
    ? `?agentUid=${agentUid}&expand=skip_links`
    : `?expand=skip_links`

  return this.connector.get(`${baseUrl}${queryParams}`)
}

export const useApiKeys = ({ organizationUuid, agentUid }: ApiKeysArgs) => {
  const { isLoading, error, data, refetch } = useContrastQuery<
    ApiKeysArgs,
    ApiKeysResponse
  >(
    [Query.API_KEYS, organizationUuid],
    getApiKeys,
    { organizationUuid, agentUid },
    { enabled: true }
  )

  return {
    isLoading,
    error,
    data,
    refetch: async () => {
      await refetch()
    }
  }
}
